import ApiService from './ApiService'

class EventService {
  static async getEvents (query) {
    return ApiService.GET('/api/events/index', query)
  }

  static async getArchives (query) {
    return ApiService.GET('/api/archives/index', query)
  }

  static async confirmEvent (eventId) {
    return ApiService.GET(`/api/events/confirm/${eventId}`)
  }

  static async deleteEvent (eventId) {
    return ApiService.GET(`/api/events/delete/${eventId}`)
  }

  static async completeEvent (eventId) {
    return ApiService.GET(`/api/events/completed/${eventId}`)
  }

  static async rejectEvent (eventId) {
    return ApiService.GET(`/api/events/reject/${eventId}`)
  }

  static async deleteEquipment (equipmentId) {
    return ApiService.POST(`/api/events/deleteEquipment/${equipmentId}`)
  }

  static async getFormCodes (eventId) {
    return ApiService.GET(`/api/events/event/${eventId}`)
  }

  static async getDownloadToken (eventId) {
    return ApiService.GET(`/api/events/generate-pdf-link/${eventId}`)
  }

  static async getFormCodesWithJwt (eventId, jwt) {
    return ApiService.GET(`/api/events/event/${eventId}`, { jwt })
  }

  static async getFormData (eventId, formCode) {
    return ApiService.GET(`/api/events/event/${eventId}`, formCode)
  }

  static async saveEventForm (eventId, form) {
    return ApiService.POST(`/api/events/event/${eventId}.json`, form)
  }

  static async submitEvent (eventId, event) {
    return ApiService.POST(`/api/events/submit/${eventId}.json`, event)
  }

  static async getEvent (eventId) {
    return ApiService.GET(`/api/events/edit/${eventId}`)
  }

  static async editEvent (eventId, data) {
    return ApiService.POST(`/api/events/edit/${eventId}.json`, data)
  }

  static async create (clientId, clientAddressEquipmentId, data) {
    return ApiService.POST(`/api/events/create/${clientId}/${clientAddressEquipmentId}.json`, data)
  }

  static async reset (eventId, formCode) {
    return ApiService.GET(`/api/events/reset/${eventId}`, { formcode: formCode })
  }
}

export default EventService
